import {css} from "@emotion/css";
import * as React from "react";
import {useEffect, useState} from "react";

const DarkModeToggle = () => {

    const [darkModeState, setDarkModeState] = useState(true);

    const body = document.body
    const lightTheme = "light"
    const darkTheme = "dark"
    let theme;

    if (localStorage) {
        theme = localStorage.getItem("theme")
    }

    if (theme === lightTheme || theme === darkTheme) {
        body.classList.add(theme)
    } else {
        theme = lightTheme
        body.classList.add(lightTheme)
    }

    useEffect(() => {

        if (typeof theme !== 'undefined') {
            setDarkModeState(theme === lightTheme)
        } else
            setDarkModeState(true)
    }, [theme])


    return (<div className={`${
        css`padding: 8px;
          transition: var(--base-transition);
          border-radius: 50%;
          cursor: pointer;

          &:hover {
            background: var(--sidebar-item-hover) !important;
          }

          &:hover > div {
            background-color: var(--color-primary) !important;
          }
        `}`}
                 onClick={_ => {
                     if (theme === darkTheme) {
                         body.classList.replace(darkTheme, lightTheme);
                         localStorage.setItem("theme", lightTheme)
                         theme = lightTheme
                         setDarkModeState(true)
                     } else {
                         body.classList.replace(lightTheme, darkTheme);
                         localStorage.setItem("theme", darkTheme)
                         theme = darkTheme
                         setDarkModeState(false)
                     }
                 }}

    >
        <div className={`
                        ${theme === darkTheme ? "ic-sun" : "ic-moon"}
                        `}/>
    </div>)

}

export default DarkModeToggle;